// CSS
require('../css/stisla.css');
require('../css/opensource_uc.css');

// JavaScript
require('./stisla');
require('./opensource_uc');
require('./load-team');